import { Component, OnInit, Input } from '@angular/core';
import { FuncService } from '../../services/func.service';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss'],
})
export class SummaryComponent implements OnInit {

  @Input() formData: any;
  @Input() apiData: any;

  constructor(public funcService: FuncService) {}

  ngOnInit() {}

  get licencePeriod() {
    return this.apiData.licencePeriods[this.formData.licencePeriod];
  }

  filterMediaTypes() {
    return this.apiData.mediaUsages.filter((mediaType) => mediaType.selected);
  }

  filterTerritories() {
    return this.apiData.territoryUsages.filter((territory) => territory.selected);
  }

}
